import { useEffect, useState } from "react";
import { meiliSearchClient } from "../../../meiliseach/client";
import { useMeilisearchStore } from "../../../stores/filter-store";
import { useRouter } from "next/navigation";
import { MeiliSearchResponse } from "./props";
import { MeiliSearchVehicleType } from "../../../types/Vehicle.types";
import { stringToSlug } from "../../../utils/common";

export const useAutocomplete = () => {
  const { push } = useRouter();
  const { query, setQuery } = useMeilisearchStore();
  const [hits, setHits] = useState<MeiliSearchVehicleType[] | null>(null);
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    const fetchHits = async () => {
      if (query !== "") {
        const index = meiliSearchClient.index("vehicles");
        const response: MeiliSearchResponse = await index.search(query, {
          filter: "",
          limit: 50,
        });
        setHits(response.hits);
        setSelectedIndex(0);
      } else {
        setHits(null);
      }
    };

    fetchHits();
  }, [query]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!hits || hits.length === 0) return;

    switch (event.key) {
      case "ArrowDown":
        if (selectedIndex < hits.length - 1) {
          setSelectedIndex(selectedIndex + 1);
        }
        break;
      case "ArrowUp":
        if (selectedIndex > 0) {
          setSelectedIndex(selectedIndex - 1);
        }
        break;
      case "Escape":
        setHits(null);
        break;
      case "Enter":
        push(
          `/veiculo/${stringToSlug(
            `${hits[selectedIndex].make}-${hits[selectedIndex].model}-${hits[selectedIndex].category ? hits[selectedIndex].category : hits[selectedIndex].style ? hits[selectedIndex].style : ""}-${hits[selectedIndex].transmission ?? hits[selectedIndex].typeStart}-${hits[selectedIndex].fuel}-${hits[selectedIndex].modelYear}-${hits[selectedIndex].color}:${hits[selectedIndex].id}`
          )}`
        );
        break;
      default:
        break;
    }
  };

  return {
    hits,
    selectedIndex,
    handleKeyDown,
    setQuery,
    setSelectedIndex,
  };
};
